import Config from 'configs'
import _ from 'lodash'

export default (whitelistEnvs = []) => {
  const env = Config.ENVIRONMENT
  if (!env) return true
  const whitelisted = _.includes(whitelistEnvs, env)
  return !whitelisted
}
